module.exports = {
  "country": "SE",
  "artist": "Herreys",
  "song": "Diggi-Loo Diggi-Ley",
  "year": "1984",
  "place": "1",
  "spotify": "4NzirQ4BrNkVaPEla2ipG4"
};